import { useGLTF } from '@react-three/drei'
import { useSpring, animated } from '@react-spring/three'
var url = './3DModels/Tassel/Tassel.gltf';


export default function Tassel(props) {

    const { nodes } = useGLTF(url)


    const { opacity } = useSpring({

        to: { opacity: props.scrollIndex === props.index ? 1 : 0 },
        from: { opacity: 0},
        //loop: { reverse: props.scrollIndex === props.index ? true : false },
        config:{
            duration:1500
        },
        delay: props.scrollIndex === props.index ?  props.delay : 0
        
        
    })

    return(
        <group
            rotation = {props.groupRotation}
    
        >
            <mesh
                position = {[0.0,-0.15,.45]}
                rotation = {[1.5705, 0.0, 0.0]}
                scale = {[10.0,10.0,10.0]}
                geometry={nodes.Tassel_01.geometry}
            >

                <animated.meshStandardMaterial attach="material" color={props.data.stdMatColor} opacity={opacity} transparent roughness={props.data.roughness}   metalness={props.data.metalness} />

            </mesh>
        </group>
    )
}

useGLTF.preload(url)
